export const getResaleTractorDataForMFACustomerUrl = (customerId, stateCode) =>
  `/mfaResaleAssets?customerId=${customerId}&stateCode=${stateCode}`;

export const getResaleTractorDataForNonMFACustomerUrl = (stateCode) =>
  `/nonMfaResaleAssets?stateCode=${stateCode}`;

export const getResaleTractorDetailsForNonMfaCustomerUrl = (assetId) =>
  `/nonMfaResaleAssets?assetId=${assetId}`;

export const getResaleTractorDetailsForMfaCustomerUrl = (customerId, assetId) =>
  `/mfaResaleAssets?customerId=${customerId}&assetId=${assetId}`;

export const postResaleAssetEnquiryUrl = (customerId) =>
  `/submitMfaResaleAssetEnquiry?customerId=${customerId}`;

export const postNonMFAResaleAssetEnquiryUrl = () =>
  `/submitNonMfaResaleAssetEnquiry`;

export const getCustomerId = (state) => state.mfaStates.userId;

export const getPreviousResaleEnquiryMfaCustomerUrl = (customerId) =>
  `/mfaPreviousResaleEnquiry?customerId=${customerId}`;

export const getPreviousResaleEnquiryNonMfaCustomerUrl = () =>
  `/nonMfaPreviousResaleEnquiry`;
